export interface IAdhocJob {
  customerName: string;
  repairOrderNumber: number | undefined;
  registrationNumber: string;
  vehicleDetails: string;
  vin: string;
}

export const ADHOC_JOB_CODE = 'ADHOC JOB';